import UseDemoButton from "./UseDemoBlock/UseDemoButton";

export default function UseDemoBlock() {
  return (
    <>
      <UseDemoButton index={1}></UseDemoButton>
      <UseDemoButton index={2}></UseDemoButton>
    </>
  );
}
